import React from "react";
import { Button, Modal } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading, FormInput } from "go-form";
import { RemoveUserAccountApi } from "../../../../../../../../../services/Api/User/userTypes";

interface Props {
	isShown: boolean;
	onHide: () => void;
	form: UseFormReturn<RemoveUserAccountApi>;
	loading: boolean;
	handleRemove: () => void;
}

const RemoveAccountConfirmationModal = ({ isShown, onHide, form, loading, handleRemove }: Props) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = form;

	return (
		<Modal onHide={onHide} show={isShown}>
			<Modal.Header closeButton>
				<Modal.Title>{t("modules.profile.field.removal_confirmation.title")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<span className="text-muted">{t("modules.profile.field.token.description")}</span>
				<FormInput name="token" errors={errors} register={register} className="mt-2" />
			</Modal.Body>
			<Modal.Footer>
				<ButtonLoading loading={loading} onClick={handleRemove} variant="danger">
					{t("modules.profile.action.confirm_removing.title")}
				</ButtonLoading>
				<Button variant="light" onClick={onHide}>
					{t("lib:common.action.cancel")}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default RemoveAccountConfirmationModal;
